export default __webpack_public_path__ + "static/media/icon_simpro_inventory.26bda784.svg";